const shouldSuppressUserFacingError = () => {
    if (typeof window === 'undefined') return false;
    return Boolean(window.Telegram?.WebApp?.initData) || process.env.NODE_ENV === 'production';
};

export const reportClientError = (error, context = 'Unhandled client error') => {
    console.error(`[ClientError] ${context}:`, error);
};

export const initGlobalErrorHandling = () => {
    if (typeof window === 'undefined') return;
    if (window.__fleepGlobalErrorHandlingInitialized) return;

    const suppress = shouldSuppressUserFacingError();

    window.addEventListener('error', (event) => {
        reportClientError(event.error || event.message, 'window.error');
        if (suppress && typeof event.preventDefault === 'function') {
            event.preventDefault();
        }
    });

    window.addEventListener('unhandledrejection', (event) => {
        reportClientError(event.reason, 'window.unhandledrejection');
        if (suppress && typeof event.preventDefault === 'function') {
            event.preventDefault();
        }
    });

    window.__fleepGlobalErrorHandlingInitialized = true;
};
